import React, { createContext, useState, useEffect, useRef } from "react";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  // Dodaj flagę zabezpieczającą
  const isLoggingOut = useRef(false);

  useEffect(() => {
    const token = localStorage.getItem("access_token");
    if (token) {
      setIsAuthenticated(true);
    } else {
      setIsAuthenticated(false);
    }
    setIsLoading(false);
  }, []);

  const logout = async () => {
    // Sprawdź flagę - jeśli wylogowanie już trwa, przerwij funkcję
    if (isLoggingOut.current) {
      console.log("Logout already in progress, ignoring duplicate call");
      return;
    }

    try {
      // Ustaw flagę na true - rozpoczynamy wylogowanie
      isLoggingOut.current = true;
      
      const refreshToken = localStorage.getItem("refresh_token");

      console.log("Refresh token:", refreshToken);
      console.log("Refresh token being sent to backend:", refreshToken);

      if (!refreshToken) {
        console.warn("No refresh token found. Logging out locally.");
        throw new Error("No refresh token available.");
      }

      // Wyślij żądanie do backendu, aby unieważnić tokeny
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/users/logout/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ refresh: refreshToken }),
      });

      console.log("Logout response status:", response.status);
      const responseData = await response.json();
      console.log("Logout response data:", responseData);

      if (!response.ok) {
        if (response.status === 401) {
          console.warn("Token is already expired or invalid. Logging out locally.");
        } else {
          console.error("Failed to log out on the server.");
          throw new Error("Server logout failed.");
        }
      } else {
        console.log("Successfully logged out on the server.");
      }
    } catch (error) {
      console.error("An error occurred during logout:", error);
    } finally {
      // Usuń tokeny z localStorage i wyloguj użytkownika lokalnie
      localStorage.removeItem("access_token");
      localStorage.removeItem("refresh_token");
      setIsAuthenticated(false);
      
      // Po zakończeniu wylogowania, resetuj flagę (z opóźnieniem dla bezpieczeństwa)
      setTimeout(() => {
        isLoggingOut.current = false;
      }, 1000);
    }
  };

  if (isLoading) {
    return <p>Loading...</p>;
  }

  return (
    <AuthContext.Provider value={{ isAuthenticated, setIsAuthenticated, logout }}>
      {children}
    </AuthContext.Provider>
  );
};